import React, { FC, useContext, useState } from 'react'
import { Container, EmailInput } from '../components'
import { FinalCard } from '../components/FinalCard.component'
import { Notification } from '../components/Notification.component'
import { GuestContext } from '../Guest.context'
import { Button, BUTTON_SIZE } from 'parkdepot-shared/components/Buttons'
import { useHistory } from 'react-router-dom'
import { ButtonContainer } from './GuestFinal.style'
import { useCustomerAPI } from '../hooks'
import Link from '@components/Link/Link.component'
import { useAuth } from '@context/AuthContext/AuthContext'
import { useTranslation } from 'react-i18next'
import { ValidUntil } from '../components/ValidUntil.component'

// wemolo-check-circle
// wemolo-cross-circle
// wemolo-info-circle

export const EmailNotSent: FC = () => {
    const { user } = useAuth()
    const { formData, setApplyWhitelistResult, endDateFormatted } = useContext(GuestContext)
    const { sendEmail } = useCustomerAPI()
    const history = useHistory()
    const [email, setEmail] = useState<string>(formData?.email || user?.email || '')
    const { t } = useTranslation()

    const handleResendEmail = async () => {
        if (!email || !formData?.plate) return
        try {
            await sendEmail({
                plate: formData.plate,
                email: email
            })
            setApplyWhitelistResult('SUCCESS')
        } catch (error) {
            console.error('Error resending email:', error)
        }
    }

    return (
        <Container>
            <FinalCard
                title={t('guest.lpUnlocked')}
                description={<ValidUntil tKey={'guest.lpUnlockedDescription'} endDate={endDateFormatted || ''} />}
                plate={formData?.plate || ''}
                country={formData?.country}
                result="success"
            />
            <Notification text={t('guest.emailNotSentNotification')} />
            <EmailInput label={t('guest.emailLabelError')} value={email} onChange={(e) => setEmail(e.target.value)} />
            <ButtonContainer>
                <Button
                    $size={BUTTON_SIZE.medium}
                    overrides={{ BaseButton: { style: { width: '100%' } } }}
                    onClick={handleResendEmail}
                >
                    {t('guest.resendEmail')}
                </Button>
                <Link onClick={() => history.push('/')}>{t('guest.continueAsGuest')}</Link>
            </ButtonContainer>
        </Container>
    )
}
